import colorLib from '@kurkle/color';

const COLORS = [
  '#36a2eb', '#ff6384', '#4bc0c0', '#ffcd57', '#ff9f40',
  '#246c9d', '#aa4258', '#328080', '#aa893a', '#aa6a2b'
];

export function transparentize(value, opacity) {
  var alpha = opacity === undefined ? 0.5 : 1 - opacity;
  return colorLib(value).alpha(alpha).rgbString();
}

export default COLORS;
